import React from 'react';
import { Col, Form, Row, Skeleton } from 'antd';
import './Form.scss';
type propsType = {
  initialValues?: object;
  onFinish?: (values: any) => void;
  onFinishFailed?: (errorInfo: any) => void;
  children?: any;
  layout?: 'horizontal' | 'vertical' | 'inline';
  form?: any;
  formName?: string;
  isLoading?: boolean;
  skeletonCount?: number;
  onValuesChange?: any;
  onFieldsChange?: (changedFields: any, allFields: any) => any;
};
export const TFForm: React.FC<propsType> = (props) => {
  const [form] = Form.useForm();
  const _layout: any = props?.layout || 'vertical';

  const renderSkeleton = () => {
    const skeletonList = [];
    const count = props?.skeletonCount || 12;
    for (let index = 0; index < count; index++) {
      skeletonList.push(
        <>
          <Col md={6} key={index}>
            <Skeleton.Input
              active={props.isLoading}
              size={'small'}
              block={true}
            />
          </Col>
        </>
      );
    }
    return skeletonList;
  };
  return (
    <Form
      name={props?.formName || 'TFForm'}
      initialValues={props?.initialValues}
      onFinish={props?.onFinish}
      onFinishFailed={props?.onFinishFailed}
      autoComplete="off"
      form={props?.form || form}
      layout={_layout}
      // size="small"
      // size='large'
      className="TFFromWrapper"
      onValuesChange={props?.onValuesChange ? props?.onValuesChange : undefined}
      onFieldsChange={props?.onFieldsChange ? props?.onFieldsChange : undefined}
    >
      <>
        {props.isLoading ? (
          <Row gutter={[10, 2]}>{renderSkeleton()}</Row>
        ) : (
          props.children
        )}
      </>
    </Form>
  );
};
